export const vcc_es_AR: any = {
    VCC_title_landing: 'Verificar tu cuenta PayPal nunca fue tan fácil',
    VCC_title: 'Verificar PayPal',
    VCC_hero_description:
        'Te ofrecemos Tarjetas VCC válidas por 3 a 5 años, especialmente diseñadas para verificar tu cuenta de PayPal de manera rápida y segura.',
    VCC_buy: 'Comprar Tarjeta VCC',
    VCC_more_info: 'Más información',

    VCC_sytems_title: 'Selecciona el método de pago para obtener tu VCC.',

    VCC_banner_title: '¿Qué te permiten estas tarjetas?',
    VCC_banner_info_li_one: 'Retirar y recibir montos más altos de dinero mensual.',
    VCC_banner_info_li_two:
        'Comprar en línea sin límites (algunas tiendas en línea solo aceptan vender sus productos a usuarios con cuenta PayPal verificada).',
    VCC_banner_info_li_three:
        'Generar más confianza tanto a tus compradores y vendedores, porque si ya estás verificado, aumenta la seguridad de cuenta.',
    VCC_banner_info_li_four:
        'Liberación más rápida de pagos retenidos, ya que PayPal suele retenerlos en base a la confianza en tu cuenta.',
    VCC_banner_info_li_five:
        'Generar más confianza tanto a tus compradores y vendedores, porque si ya estás verificado, aumenta la seguridad de cuenta.',

    VCC_text_flyer:
        'Las tarjetas VCC <span class="vcc-flyer">están destinadas única y exclusivamente para verificar tu cuenta de PayPal.</span>',

    VCC_verified_title: 'Ventajas de tener una cuenta PayPal verificada',
    VCC_verified_info_p_one:
        'Una Tarjeta de Crédito Virtual o VCC (Virtual Credit Card) al igual que una tarjeta física, tiene numeración, fecha de caducidad y código de verificación. En realidad, se trata de una versión digital de las tarjetas físicas que todos conocemos, sólo que no debes esperar a que llegue a tu domicilio o debas retirarla en tu banco.',
    VCC_verified_info_p_two:
        'Cuando adquirimos una Tarjeta de Crédito Virtual, podemos acceder a varios beneficios. Uno de los beneficios que tenemos es el de poder verificar una cuenta de Paypal.',
    VCC_verified_info_p_three: 'En Saldoar te brindamos VCC con una vigencia de 3 a 5 años, para que puedas verificar tu cuenta de PayPal.',

    VCC_verified_question: '¿Qué beneficios tiene una cuenta PayPal verificada?',
    VCC_verified_li_one: 'Retirar y recibir montos más altos de dinero mensual que una cuenta no verificada.',
    VCC_verified_li_two: 'Comprar en tiendas en línea que solo aceptan vender sus productos a usuarios con cuenta PayPal verificada.',
    VCC_verified_li_three:
        'Generar más confianza tanto a tus compradores como vendedores, ya que este detalle puede ser visto por la contraparte.',
    VCC_verified_li_four: 'Liberación más rápida de pagos retenidos, ya que PayPal suele retenerlos en base a la confianza en tu cuenta.',
    VCC_verified_li_five: 'Reducir considerablemente las posibilidades de que tu cuenta sea limitada.'
};
